var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"price-display"},[(_vm.showAb)?_c('span',[_vm._v("AB ")]):_vm._e(),_vm._v(_vm._s(_vm.priceText)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }